import api from 'Cloud/Application/api';
import domainFoldersModule from 'Cloud/Application/domainFolders';
import config from 'Cloud/config';
import $ from 'jquery';
import { extInfo } from 'lib/extInfo';
import { searchLoadMoreSuccess, searchLoadRequest, searchLoadSuccess } from 'reactApp/modules/search/search.module';
import { getLoadMoreLimit } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { store as reduxStore } from 'reactApp/store';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

var emptyResult = {
    home: '/',
    kind: 'storage',
    list: [],
    name: '/',
    type: 'folder',
};
var searchTypeExtensions = {};

var getExtsBySearchType = function (searchType) {
    var extensions = searchTypeExtensions[searchType] || (searchTypeExtensions[searchType] = extInfo.getExtsByKind(searchType).join(','));

    return extensions;
};

var MAX_RESULT_COUNT = getLoadMoreLimit(EStorageType.search);

export default function (app) {
    var searchActive = app.features.search.isEnabled() && config.get('SEARCH_AVAILABLE');
    if (!searchActive) {
        app.searchController = {
            load: function () {
                var deferred = new $.Deferred();
                deferred.reject(null, 404, {});
                return deferred;
            },
            sendRadarStatistics: function () {},
        };
        return;
    }

    var searchController = {
        _limit: 500,
        _offset: 0,
        _searchResult: null,
        _loadCriteriaParams: {},
        _routeChangeEndHandler: function () {
            if (!app.isSearch()) {
                searchController._searchResult = null;
                searchController._loadCriteriaParams = {};
                app.off('routeChangeEnd', searchController._routeChangeEndHandler);
            }
        },
        getLimit: function () {
            return this._limit;
        },
        getOffset: function () {
            return this._offset;
        },
        loadNext: function ({ dontDispatch } = {}) {
            var searchResultList = this.getSearchResultList();
            var nextResultList = searchResultList.slice(this.getOffset(), this.getOffset() + this.getLimit());
            var hashListFiles;
            var deferred;
            var hashList;
            var apiRequestCallDeltaT;

            if (!nextResultList.length) {
                deferred = new $.Deferred();
                deferred.resolve({ ...emptyResult });

                // return Promise.resolve({
                //     ...emptyResult,
                // });
                return deferred.promise();
            }

            hashListFiles = this._getHashListFiles(nextResultList);
            hashList = this._getPropertyList(hashListFiles, 'hash');

            apiRequestCallDeltaT = performance.now();

            return this.loadVirusScan(hashList)
                .then(
                    function (hashListResult) {
                        var resultListLength;
                        var searchResult = {};

                        apiRequestCallDeltaT = performance.now() - apiRequestCallDeltaT;
                        resultListLength = searchResultList.length;

                        searchController._sendVirusScanStatistics(200, apiRequestCallDeltaT);

                        hashListFiles.forEach(function (hashListFile) {
                            $.extend(true, hashListFile, hashListResult[hashListFile.hash]);
                        });

                        searchController._offset += searchController.getLimit();

                        searchController._offset =
                            searchController._offset < resultListLength ? searchController._offset : resultListLength;

                        searchResult = $.extend(true, {}, searchController._searchResult);
                        searchResult.list = nextResultList;

                        return searchResult;
                    },
                    function (response, status) {
                        apiRequestCallDeltaT = performance.now() - apiRequestCallDeltaT;

                        searchController._sendVirusScanStatistics(status, apiRequestCallDeltaT);

                        return [];
                    }
                )
                .then((result) => {
                    if (!dontDispatch) {
                        reduxStore.dispatch(searchLoadMoreSuccess(JSON.parse(JSON.stringify(result))));
                    }

                    return result;
                });
        },
        loadDomainFolders: function () {
            return domainFoldersModule.load().then(
                function (domainFolders) {
                    return {
                        domainFolders: domainFolders,
                        domainFoldersIdList: searchController._getPropertyList(domainFolders, 'id'),
                    };
                },
                function () {
                    return [];
                }
            );
        },
        _getPropertyList: function (items, property) {
            items = Array.isArray(items) ? items : [];

            return items.map(function (item) {
                return (item && item[property]) || void 0;
            });
        },
        _getHashListFiles: function (resultList) {
            resultList = resultList || [];

            return resultList.filter(function (resultListItem) {
                return resultListItem && 'hash' in resultListItem;
            });
        },
        _sendVirusScanStatistics: function (status, apiRequestCallDeltaT) {
            apiRequestCallDeltaT = Number(apiRequestCallDeltaT);
            status = Number(status);

            this.sendRadarStatistics('virus-scan', {
                apiRequestCallDeltaT: apiRequestCallDeltaT,
                status: status,
                kaktam: {
                    label: 'virus-scan',
                    data: {
                        time: apiRequestCallDeltaT.toFixed(3),
                        offset: this.getOffset(),
                        resultsCount: this.getSearchResultList().length,
                    },
                },
            });
        },
        _sendSearchStatistics: function (status, query, searchType, apiRequestCallDeltaT) {
            apiRequestCallDeltaT = Number(apiRequestCallDeltaT);
            status = Number(status);
            query = String(query);
            searchType = String(searchType);

            this.sendRadarStatistics('search', {
                kaktam: {
                    label: 'search',
                    data: {
                        time: apiRequestCallDeltaT.toFixed(3),
                        query: query,
                        searchType: searchType,
                        resultCount: this.getSearchResultList().length,
                    },
                },
                apiRequestCallDeltaT: apiRequestCallDeltaT,
                status: status,
            });
        },
        sendRadarStatistics: function (radarGroup, params) {
            var radar;
            var apiRequestCallDeltaT;

            params = params || {};

            if (!radarGroup) {
                throw new Error('SearchController#sendRadarStatistics: expected radarGroup to be non-empty string');
            }

            radar = RADAR.group(radarGroup);
            apiRequestCallDeltaT = typeof params.apiRequestCallDeltaT == 'number' ? params.apiRequestCallDeltaT : NaN;
            apiRequestCallDeltaT = Math.round(apiRequestCallDeltaT);

            if (params.status === 200) {
                radar.add('success_all', apiRequestCallDeltaT);
            } else {
                radar.add('fail_all', apiRequestCallDeltaT);
                radar.add('fail_status-' + params.status + '_all', apiRequestCallDeltaT);
            }

            if (Object(params.kaktam) === params.kaktam) {
                if (!params.kaktam.label) {
                    throw new Error('SearchController#sendRadarStatistics: expected params.kaktam.label to be non-empty string');
                }

                params.kaktam.data = params.kaktam.data || {};

                radar.kaktam(params.kaktam.label, JSON.stringify(params.kaktam.data));
            }

            radar.send();
        },
        loadVirusScan: function (hashList) {
            hashList = hashList || [];

            return api.folder.viruscan({
                // eslint-disable-next-line @typescript-eslint/camelcase
                hash_list: hashList,
            });
        },
        // CLOUDWEB-7395;
        forceLoadOnceNextTime: function () {
            this._loadCriteriaParams = {};
        },
        hasToLoad: function (id, queryParams) {
            queryParams = queryParams || app.getState().params || {};

            return this._loadCriteriaParams.query !== queryParams.query || this._loadCriteriaParams.searchType !== queryParams.searchType;
        },
        getSearchResultList: function () {
            return [].concat((this._searchResult && this._searchResult.list) || []);
        },
        _addCountInfoToSearchResult: function () {
            var searchResult = this._searchResult;

            if (searchResult == null) {
                return searchResult;
            }

            searchResult.count = {
                files: 0,
                folders: 0,
            };

            this.getSearchResultList().forEach(function (item) {
                if (item) {
                    if (item.kind === 'file') {
                        searchResult.count.files++;
                    } else {
                        searchResult.count.folders++;
                    }
                }
            });

            return searchResult;
        },
        load: function (id) {
            var params = app.getState().params;
            var deferred = new $.Deferred();
            var searchType = params.searchType || 'all';
            var query = (params.query || '').trim();
            var apiRequestParams;
            var extensions;
            var apiRequestCall;
            var apiRequestCallDeltaT;

            sendPaymentGa({ eventCategory: ECategoryGa.entered, action: 'result-search' });
            sendPaymentGa({ eventCategory: ECategoryGa.entered, action: 'page-entered', source: 'result-search' });

            reduxStore.dispatch(searchLoadRequest());

            id = (query || id).trim() || '/';
            extensions = getExtsBySearchType(searchType);

            apiRequestParams = {
                q: query,
                path: '/',
                limit: MAX_RESULT_COUNT,
                depth: 4294967295, // 2^32-1
            };

            if (extensions) {
                apiRequestParams.ext = extensions;
            } else {
                if (searchType === 'folder') {
                    // Магический привет от API
                    // "type=d" означает искать по типу "папка"
                    apiRequestParams.type = 'd';
                } else {
                    searchType = 'all';
                    if (id === '/') {
                        deferred.resolve($.extend(true, {}, emptyResult), 200, {});
                        return deferred;
                    }
                }
            }

            apiRequestCallDeltaT = performance.now();
            apiRequestCall = api.folder.find(apiRequestParams);

            searchController._offset = 0;

            app.on('routeChangeEnd', searchController._routeChangeEndHandler);

            apiRequestCall.always(function (searchResult, status) {
                apiRequestCallDeltaT = performance.now() - apiRequestCallDeltaT;

                // Сохраняем результат поисковой выдачи
                searchController._searchResult = searchResult;

                // Добавляем информацию count: {files: <number>, folders: <number>}
                searchController._addCountInfoToSearchResult();

                searchController._sendSearchStatistics(status, apiRequestParams.q, searchType, apiRequestCallDeltaT);

                if (status !== 200) {
                    deferred.resolve($.extend(true, {}, emptyResult), 200, {});
                    return;
                }

                searchController._loadCriteriaParams.query = query;
                searchController._loadCriteriaParams.searchType = searchType;

                app.emit('api:searchResult', {
                    resultOverQuota: searchController.getSearchResultList().length > MAX_RESULT_COUNT - 1,
                });

                searchController.loadDomainFolders().then(
                    function (result) {
                        var domainFoldersIdList = result.domainFoldersIdList;

                        searchResult.list.forEach(function (item) {
                            if (domainFoldersIdList.indexOf(item.home) !== -1) {
                                item.kind = 'domain-folder';
                            }
                        });

                        searchController.loadNext({ dontDispatch: true }).then(
                            function (searchResult) {
                                deferred.resolve(searchResult, 200, {});
                            },
                            function () {
                                deferred.reject([], 500, null);
                            }
                        );
                    },
                    function () {
                        deferred.reject([], 500, null);
                    }
                );
            });

            deferred.done((result, status, response) => {
                reduxStore.dispatch(searchLoadSuccess(JSON.parse(JSON.stringify(result))));
                return deferred.resolve(result, status, response);
            });

            return deferred;
        },
    };

    app.searchController = searchController;
}
